/**
 * Safely retrieves initial data injected by the server
 */
export const getInitialData = <T = any>(): T => {
  if (typeof window !== 'undefined' && window.__INITIAL_DATA__) {
    return window.__INITIAL_DATA__ as T;
  }
  return {} as T;
};
